module.exports = __webpack_public_path__ + "static/img/finance.65a9462e.png";